import { BaseFund, Fund } from '@ddv/models';

export function getFunds(funds: Fund[]): BaseFund[] {
    return funds.map((f) => ({ fundId: f.fundId, fundName: f.fundName }));
}
